<div class="toolbar text-default w-full px-6 flex items-center">
  <button
    (click)="openSidenav()"
    [class.hidden]="isDesktop$ | async"
    [attr.aria-label]="'layout.expand' | translate"
    mat-icon-button
    type="button">
    <mat-icon svgIcon="mat:menu" />
  </button>

  <img
    alt="Logo"
    class="mobile-logo"
    [src]="logoUrl" />

  <span class="flex-1"></span>
</div>
